import { useQuery } from '@tanstack/react-query'
import { getVideoReviews } from '../data/api'

/* The customer video reel. Filed rarely, read on every visit — the same
   five-minute freshness the catalogue gets. A failure is not retried into
   the ground: the section has a static reel to fall back on, so one retry
   is diligence and three would be a spinner nobody asked for. */

export const videoReviewKeys = { all: () => ['video-reviews'] as const }

export function useVideoReviews() {
  return useQuery({
    queryKey: videoReviewKeys.all(),
    queryFn: getVideoReviews,
    staleTime: 5 * 60_000,
    retry: 1,
  })
}
